// The reseller's price list as server state. The domain order forms will read tldPricingQuery for
// the price they show (guide, rule 25), so this is the feature's public surface.
import { queryOptions } from "@tanstack/react-query";
import { listTldPricing } from "./api";

export const pricingKeys = {
  all: ["pricing"] as const,
  tlds: () => [...pricingKeys.all, "tlds"] as const,
};

/** Every TLD KilatDomain offers, in the reseller's order, with what it pays and sells each for. */
export const tldPricingQuery = () =>
  queryOptions({ queryKey: pricingKeys.tlds(), queryFn: async () => (await listTldPricing()).data });
